import { Paper } from '@mantine/core';
import ShippingListSection from '../components/ShippingListSection';
import ShippingTiersSection from '../components/ShippingTiersSection';
import HolidayManagementSection from '../components/HolidayManagementSection';
import './AdminSettings.css';

export default function AdminSettings() {
  return (
    <main className="dashboard-view-wrapper" aria-labelledby="admin-settings-title">
      <header className="dashboard-page-header">
        <div>
          <h1 id="admin-settings-title" className="dashboard-page-title">Settings</h1>
          <p className="dashboard-page-description">
            Manage platform-wide configuration for shipping, products, and more.
          </p>
        </div>
      </header>

      <div className="admin-settings-sections">
        <Paper
          withBorder
          p="xl"
          radius="md"
          component="section"
          aria-label="Shipping Costs configuration"
        >
          <ShippingTiersSection />
        </Paper>

        <Paper
          withBorder
          p="xl"
          radius="md"
          component="section"
          aria-label="Holiday Management"
        >
          <HolidayManagementSection />
        </Paper>

        <Paper
          withBorder
          p="xl"
          radius="md"
          component="section"
          aria-label="Shipping Countries configuration"
        >
          <ShippingListSection listKey="country" title="Shipping Countries" description="Control which countries delivery is available to." />
        </Paper>

        <Paper
          withBorder
          p="xl"
          radius="md"
          component="section"
          aria-label="Shipping Cities configuration"
        >
          <ShippingListSection listKey="city" title="Shipping Cities" description="Control which cities delivery is available to within each country. Cities with free shipping enabled get free delivery for all orders." />
        </Paper>
      </div>
    </main>
  );
}
